// extracted by css-extract-rspack-plugin
var _1 = "we";
var _2 = "ut";
var _3 = "uw";
var _4 = "wf";
var _5 = "la";
var _6 = "wc";
var _7 = "wg";
var _8 = "uu";
var _9 = "wb";
var _a = "uv";
export { _1 as "circleStroke", _2 as "darkBlue", _3 as "gray", _4 as "green", _5 as "iconBaseComponent", _6 as "lightBlue", _7 as "lightGray", _8 as "magenta", _9 as "none", _a as "white" }
